const flattenSubMenu = subMenu => {
  return subMenu.reduce(function(flat, toFlatten) {
    return flat.concat(
      !toFlatten.pageId && toFlatten.subMenu && toFlatten.subMenu.length
        ? flattenSubMenu(toFlatten.subMenu.map(n => ({ ...n, menuName: `${toFlatten.menuName} - ${n.menuName}` })))
        : toFlatten,
    );
  }, []);
};

export default flattenSubMenu;
